exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".order_amount {\n  font-weight: bold;\n  font-size: 1.8rem; }\n\n.order_name {\n  font-size: 1.6rem; }\n\n.order_search {\n  margin-bottom: 1em; }\n\n.btn-group-active-yes {\n  background-color: #18ba62;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500; }\n\n.btn-group-active-block {\n  background-color: #dddddd;\n  color: #404040;\n  font-size: 14px;\n  font-weight: 500; }\n\n.table-responsive {\n  overflow-x: auto;\n  white-space: nowrap; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/user/user.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/pages/user/user.css
// module chunks = 0